/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heating_Curve_Max_Offset_Adaptation_LabelInputs */



/**
* | output |
* | --- |
* | "Maximum adaptation of heating curve points:" |
*
* @param {Heating_Curve_Max_Offset_Adaptation_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const heating_curve_max_offset_adaptation_label = /** @type {((inputs?: Heating_Curve_Max_Offset_Adaptation_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heating_Curve_Max_Offset_Adaptation_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Maximum adaptation of heating curve points:")
	return /** @type {LocalizedString} */ ("Maximum d'adaption des points de la loi d'eau:")
});